module.exports = __webpack_public_path__ + "static/media/staff-bottlecap.cfa2fe51.png";